module.exports = __webpack_public_path__ + "static/media/banner3.7c8158d3.jpg";